import { CredenciaisPayLoad } from '@cei-ufg/ngx-cei-sso-client';

export const credenciaisMapper: CredenciaisPayLoad = (customPayload: any) => {
  return {
    login: customPayload.usuario,
    password: customPayload.senha,
  };
};
